/**
 * IMPORTANT! Do not Lazy Load Banners.
 * It will cause CLS issues if we loaded the dependency with some delays.
 */
import { Banners } from './Banners';

export default Banners;
